import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';

export const ProductAlertInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  width: 100%;

  hr {
    border-bottom: 1px solid ${colors.lightGray1};
  }
`;

export const ProductInfoName = styled.div`
  flex-grow: 1;
  margin: 0 1rem;

  h2 {
    font-size: 1rem;
    font-weight: normal;
    margin-bottom: 0.25rem;
  }
`;

export const ProductInfoImage = styled.img`
  max-height: 60px;
  min-width: 40px;
`;

export const ProductInfoPrice = styled.div`
  font-weight: bold;
  white-space: nowrap;
  color: ${colors.red1};
`;
